// extracted by mini-css-extract-plugin
export var container = "not-found-module--container--fda7a";
export var content = "not-found-module--content--dc0ed";
export var eyebrow = "not-found-module--eyebrow--e9621";
export var headline = "not-found-module--headline--62495";
export var notFound = "not-found-module--notFound--762dd";
export var row = "not-found-module--row--f4593";